<template>
  <loader v-if="dataLoading" />

  <prime-dialog id="new-fornitore" v-model:visible="dialog.newFornitore.visible" :style="{width: '1280px', height:'1440px'}" :modal="true">
    <template #header>
      <h3>Aggiungi Fornitore o Conto</h3>
    </template>

    <div class="formgrid grid" >
      <div class="field col-12 md:col-6" >
        <label for="fornitore">Fornitore</label>
        <auto-complete 
          id="fornitore"
        
          v-model="dialog.newFornitore.data.fornitore" 
          :suggestions="dialog.newFornitore.data.fornitoriFiltered"
          field="ragsoc" 

          @complete="onSearchFornitore($event)" 
          @item-select="onSelectFornitore($event)"

          class="inputfield w-full"
        />
      </div>
      <div class="field col-12 md:col-6">
        <label for="conto"  style="width: 150px; display: inline-block;">Conto</label>
        <prime-input-text 
          id="conto" 
          v-model="dialog.newFornitore.data.conto" 
          type="text" 
          class="inputfield w-full" 
        />
      </div>
    </div>

    <data-table 
      :value="dialog.newFornitore.data.descrizioni" 
      v-model:selection="dialog.newFornitore.data.descrizioniSelected" 

      dataKey="id" 

      responsiveLayout="scroll" 
    >
      <column selectionMode="multiple" headerStyle="width: 3em"></column>
      <column field="descrizione" header="Descrizione"></column>
    </data-table>

    <div class="p-d-flex p-p-3 card">
      <prime-button label="Aggiungi" class="p-button-rounded p-button-success mr-2" @click="onAddFornitore()" />
    </div>

  </prime-dialog>

  <prime-dialog id="update-conto" v-model:visible="dialog.updateConto.visible" :style="{width: '1280px', height:'1440px'}" :modal="true">
    <template #header>
      <h3>Modifica conto</h3>
    </template>

    <div class="formgrid grid">
      <div class="field col-12 md:col-4">
        <label for="conto">Conto</label>
        <prime-input-text 
          id="conto" 
          v-model="dialog.updateConto.data.conto.conto" 
          type="text" 
          :disabled="true"
          class="inputfield w-full" 
        />
      </div>
    </div>

    <data-table 
      :value="dialog.updateConto.data.descrizioni" 
      v-model:selection="dialog.updateConto.data.selected" 

      dataKey="id" 

      responsiveLayout="scroll" 
    >
      <column selectionMode="multiple" headerStyle="width: 3em"></column>
      <column field="descrizione" header="Descrizione"></column>
    </data-table>

    <div class="p-d-flex p-p-3 card">
      <prime-button label="Modifica" class="mb-auto" @click="onUpdateConto()" />
    </div>

    <template #footer>
      <prime-button label="Chiudi" icon="pi pi-check" @click="onCloseUpdateContoDialog($event)" autofocus />
    </template>
  </prime-dialog>

  <!--  -->

  <div class="page">
    
    <div class="p-d-flex p-p-3 card">
      <prime-button label="Aggiungi Fornitore o Conto" icon="pi pi-plus-circle"  class="p-button-rounded p-button-success mr-2" @click="dialog.newFornitore.visible = true" />
    </div>

    <accordion :multiple="true" >
      <accordion-tab v-for="(fornitore, index_fornitore) in fornitori" :key="index_fornitore">
        <template #header>
          <span>{{ fornitore.ragsoc }}</span>
        </template>

        
        <div v-for="(descrizioni, index_conto) in fornitore.descrizione_conti" :key="index_conto" class="mb-2">
          <data-table 
            :value="descrizioni" 
            dataKey="id_descrizione"

            responsiveLayout="scroll" 

            rowGroupMode="rowspan" 
            groupRowsBy="conto"

            sortMode="multiple" 
          >
            <column field="conto" header="Conto" headerStyle="width: 50px"></column>
            <column field="descrizione" header="Descrizione"></column>
          </data-table>

          <div class="p-d-flex p-p-3 card">
            <prime-button label="Rimuovi" icon="pi pi-times" class="p-button-danger mr-2" @click="onRemoveConto(fornitore.conti[index_conto].id)"/>
            <prime-button label="Modifica" icon="pi pi-check" class="p-button-success" @click="onOpenDescrizioniContoDialog(fornitore.id, fornitore.conti[index_conto])"/>
          </div>
        </div>

      </accordion-tab>
    </accordion>

  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/utility-fornitori-conti-acquisto-service'

import Loader from '@/components/Loader.vue'

// import PrimeCheckbox from 'primevue/checkbox'
import PrimeButton from 'primevue/button'
import PrimeDialog from 'primevue/dialog'
import PrimeInputText from 'primevue/inputtext'
// import PrimeTextarea from 'primevue/textarea'

export default { 
  components: {
    Loader,
    // PrimeCheckbox,
    PrimeButton,
    PrimeDialog,
    PrimeInputText,
    // PrimeTextarea,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      dataLoading: false,

      dialog:{
        newFornitore: {
          data: {
            conto: '',
            fornitore: null,

            fornitoriFiltered: [],
            fornitori: [],

            descrizioniSelected: [],
            descrizioni: [],
          },

          visible: false,
        },

        updateConto: {
          data: {
            conto: '',
            selected: [],
            descrizioni: [],
          },

          visible: false,
        }
      },

      // validate: {
      //   errors:{
      //     codice: false
      //   }
      // },

      fornitori: [],

      data: {
        newItem: {
          
        }
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getFornitori()
    this.getFornitoriForDialog()
  },

  methods:{

    onCloseNewFornitoreDialog(/** event **/){
      this.dialog.newFornitore.visible = false
      this.resetNewItemDialogData()
    },

    onCloseUpdateContoDialog(/** event **/){
      this.dialog.updateConto.visible = false
      this.resetUpdateDialogData()
    },

    onOpenDescrizioniContoDialog(idFornitore, conto){
      this.getDescrizioni(idFornitore, this.dialog.updateConto.data)
      
      this.dialog.updateConto.data.conto = conto
      this.dialog.updateConto.data.selected = conto.descrizioni

      this.dialog.updateConto.visible = true
    },

    onAddFornitore(){
      const fornitoreId = this.dialog.newFornitore.data.fornitore.id
      const conto = this.dialog.newFornitore.data.conto
      const descrizioni = this.dialog.newFornitore.data.descrizioniSelected

      this.service.create(fornitoreId, conto, descrizioni).then((res) => {
        if(res.success){
          this.getFornitori()

          this.dialog.newFornitore.visible = false
          this.resetNewItemDialogData()
        }else{
          alert(`Ci sono stati problemi durante la creazione del nuovo conto ${this.dialog.updateConto.data.conto.conto}`)
        }
      })
    },

    onUpdateConto(){
      const contoId = this.dialog.updateConto.data.conto.id
      const descrizioni = this.dialog.updateConto.data.selected

      this.service.update(contoId, descrizioni).then((res) => {
        if(res.success){
          this.getFornitori()

          this.dialog.updateConto.visible = false
          this.resetUpdateDialogData()
        }else{
          alert(`Ci sono stati problemi durante l'aggiornamento del conto ${this.dialog.updateConto.data.conto.conto}`)
        }
      })
    },

    onRemoveConto(contoId){
      this.service.delete(contoId).then((res) => {
        if(res.success){
          this.getFornitori()
        }
      })
    },

    onSearchFornitore(event){
      const filter = event.query;

      if(filter.length > 2){
        this.dialog.newFornitore.data.fornitoriFiltered = this.dialog.newFornitore.data.fornitori
        .filter( (el) => el.ragsoc.toUpperCase().indexOf(filter.toUpperCase()) >= 0 )
      }else{
        this.dialog.newFornitore.data.fornitoriFiltered = []
      }
    },

    onSelectFornitore(event){
      this.getDescrizioni(event.value.id, this.dialog.newFornitore.data)
    },

    /////

    navigateToTab(href){
      window.open(href, '_blank')
    },

    getFornitori(){
      this.dataLoading = true

      this.service.getAll().then((res) => {
        this.fornitori = res.items.map((el) => {
          return {
            id: el.id,
            ragsoc: el.ragsoc,
            conti: el.conti,
            descrizione_conti: el.conti.map((c) => c.descrizioni.reduce((acc, d) => acc.concat({
              id_conto: c.id,
              conto: c.conto,
              id_descrizione: d.id,
              descrizione: d.descrizione,
            }), []))
          }
        }) 
      }).finally(() =>{
        this.dataLoading = false
      })
    },

    getFornitoriForDialog(){
      this.dataLoading = true

      this.service.getFornitori().then((res) => {
        this.dialog.newFornitore.data.fornitori = res.items
      }).finally(() =>{
        this.dataLoading = false
      })
    },

    getDescrizioni(idFornitore, data){
      this.dataLoading = true

      this.service.getDescrizioni(idFornitore).then((res) => {
        data.descrizioni = res.items
      }).finally(() =>{
        this.dataLoading = false
      })
    },

    resetNewItemDialogData(){
      this.dialog.newFornitore.data.conto = ''
      this.dialog.newFornitore.data.fornitore = null
      
      this.dialog.newFornitore.data.fornitoriFiltered = []

      this.dialog.newFornitore.data.descrizioniSelected = []
      this.dialog.newFornitore.data.descrizioni = []
    },

    resetUpdateDialogData(){
      this.dialog.updateConto.data.conto = ''
      this.dialog.updateConto.data.selected = []
      this.dialog.updateConto.data.descrizioni = []
    },

  },

  computed:{
    
  },

  watch: {
    
  },
}
</script>

<style scoped>
.box-center{
  text-align: center;
}
</style>
